module.exports = __webpack_public_path__ + "img/bus_05.c57e35d0.jpg";